import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  const navLinks = [
    { href: "/for-startups", label: "For Startups" },
    { href: "/for-talent", label: "For Talent" },
    { href: "/associate-partner-programme", label: "Partner Programme" },
    { href: "/jobs", label: "Jobs" },
    { href: "/tools", label: "Tools" },
    { href: "/about", label: "About" },
    { href: "/insights", label: "Insights" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav
      data-testid="navigation"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled || isMobileOpen ? "bg-white/98 backdrop-blur-md shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-8 md:px-16">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex flex-col" data-testid="logo">
            <div className="flex items-center gap-3">
              <span className="font-display text-2xl tracking-tight">Magnus Kor</span>
              <span className="w-px h-5 bg-[#B8860B]"></span>
              <span className="text-[10px] uppercase tracking-[0.2em] text-gray-500">Talent Partners</span>
            </div>
            <span className="text-[9px] text-gray-400 tracking-wide mt-0.5">Powered by <span className="text-[#B8860B]">L&D Nexus</span></span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center gap-10">
            {navLinks.map(link => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm transition-colors ${
                  isActive(link.href) ? "text-[#B8860B]" : "text-gray-600 hover:text-gray-900"
                }`}
                data-testid={`nav-${link.label.toLowerCase().replace(/\s/g, '-')}`}
              >
                {link.label}
              </Link>
            ))}
            <Link to="/contact" className="btn-luxury btn-luxury-dark text-xs py-3 px-6" data-testid="nav-contact">
              Contact
            </Link>
          </div>

          {/* Mobile Toggle */}
          <button className="lg:hidden p-2" onClick={() => setIsMobileOpen(!isMobileOpen)} data-testid="mobile-toggle">
            {isMobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileOpen && (
          <div className="lg:hidden absolute top-full left-0 right-0 bg-white border-t border-gray-100 shadow-lg" data-testid="mobile-menu">
            <div className="px-8 py-8 space-y-6">
              {navLinks.map(link => (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`block text-lg ${isActive(link.href) ? "text-[#B8860B]" : "text-gray-700"}`}
                >
                  {link.label}
                </Link>
              ))}
              <Link to="/contact" className="btn-luxury btn-luxury-dark inline-block mt-4">Contact</Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
